import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GridViewComponent } from '../grid-view/grid-view.component';
import { GlobalServices } from '../../services/global.service';
import { MyTasksService } from '../../services/my-Tasks.service';
import { Listing } from '../../models/listing.model';
import { Languages, Service } from '../../models/enums.model';
import { User } from '../../../front-user/shared/models/user.model';
import { AuthenticationService } from '../../../front-user/shared/services/authentication.service';
import { EtenderService } from '../../services/etender.service';
import { ETenderAdminTypes } from '../../models/e-tender.model';

@Component({
  selector: 'app-SmallUnits-tasks',
  templateUrl: './SmallUnits-tasks.component.html'
})

export class SmallUnitsTasksComponent implements OnInit {
  //#region Properties & Variables
  collection: Listing;
  pageSize = 15;
  itemsMenu: MenuItem[] = [];
  gridName = '';
  longhaulEbookingServices = [Service.AgentRegisteration, Service.EBooking, Service.FeesEstimation,
  Service.LongHaul, Service.TransitRequest, Service.UpdateAgentProfile];
  SmallUnitServices = [Service.SmallUnits];
  //#endregion
  @ViewChild('SmallUnitsTasks',{static: false}) gridView: GridViewComponent;
  public currentUser: User = new User();
  userGroups: any;
  isEtenderDivisionManager: boolean = false;
  constructor(private myTasksService: MyTasksService, private global: GlobalServices,
    private authenticationService: AuthenticationService, private etenderSrv: EtenderService) {
      this.currentUser = this.authenticationService.currentUserValue;
      //this.currentUser = this.global.user;
      this.etenderSrv.GetUserGroups(this.authenticationService.currentUserValue.Email).subscribe(
        data => {
          this.userGroups = data.Data;
          if (this.userGroups.filter(a => a == ETenderAdminTypes.SCAServices_ETenderPurchasingDivisionManager || a == ETenderAdminTypes.SCAServices_ETenderTechnicalDivisionManagers).length > 0){
            this.isEtenderDivisionManager = true;
          }
        });
  }

  ngOnInit()
  {
    this.initiateMyTasks();
  }
  loadMyTasks(pPageIndex: number, pPrimarySortBy: string, pPrimarySortDirection: string, pSecondarySortBy: string, pSecondarySortDirection: string) {
    this.myTasksService.GetPendingTasksByServices(this.SmallUnitServices, this.currentUser.UserName, pPageIndex, this.pageSize, pPrimarySortBy, pPrimarySortDirection,
      pSecondarySortBy, pSecondarySortDirection).subscribe(
      // this.myTasksService.getPendingTasks("nashwa.mostafa@linkdev.com", pPageIndex, this.pageSize, pSortBy, pSortDirection).subscribe(
      data => this.collection = data.Data,
      () => console.log('Something went wrong!!'),
      () => this.loadCollectionCompleted(pPrimarySortBy, pPrimarySortDirection, pSecondarySortBy, pSecondarySortDirection)
    );
  }
  loadCollectionCompleted(pPrimarySortBy: string, pPrimarySortDirection: string, pSecondarySortBy: string, pSecondarySortDirection: string) {
    this.loadItemsMenu();
    this.gridName = this.collection.Collection.filter(e => this.SmallUnitServices
      .find(a => a == e['ServiceId'])).length > 0 ? 'SHARED.SmallUnits_TASKS' : 'SHARED.MYTASKS';

    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      'Tasks/GetPendingTasksByService?Services=' + this.SmallUnitServices +
      '&userName=' + this.currentUser.UserName +
      '&pageIndex={PAGEINDEX}&pageSize=' + this.pageSize +
      '&primSortBy={SORTBY1}&primSortDirection={SORTDIR1}' +
      '&secSortBy={SORTBY2}&secSortDirection={SORTDIR2}' +
      '&lang=' + (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En'),
      this.gridName , this.itemsMenu, pPrimarySortBy, pPrimarySortDirection, pSecondarySortBy, pSecondarySortDirection, 'SmallUnitsTasks');

    this.global.isLoaderEnabled = false;
  }
  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = 'Details';
    this.itemsMenu[0].TitleAr = 'التفاصيل';
    this.itemsMenu[1] = new MenuItem();
    this.itemsMenu[1].Title = 'Request History';
    this.itemsMenu[1].TitleAr = 'تاريخ الطلب';
    if (this.currentUser.IsAdmin) {
      this.itemsMenu[2] = new MenuItem();
      this.itemsMenu[2].Title = 'Workflow Status';
      this.itemsMenu[2].TitleAr = 'حالة مسار العمل';
      if (this.isEtenderDivisionManager){
      this.itemsMenu[3] = new MenuItem();
      this.itemsMenu[3].Title = 'Pending Admins';
      this.itemsMenu[3].TitleAr = 'المشرفون المعلق عليهم';
      }
    }
  }
  resetOrder()
  {
    //this.initiateMyTasks();
    this.global.myTasksSortsndPagingCriteria=[];
    this.global.isLoaderEnabled = true;
    this.loadMyTasks(0, 'SubmissionDate', 'DESC', 'SubmissionDate', 'DESC');
  }
  initiateMyTasks()
  {
    this.global.isLoaderEnabled = true;
    if(this.global.myTasksSortsndPagingCriteria.length > 0)
    {
     this.loadMyTasks(this.global.myTasksSortsndPagingCriteria[0].currentPage - 1,
                      this.global.myTasksSortsndPagingCriteria[0].sortingColumns[1][0], this.global.myTasksSortsndPagingCriteria[0].sortingColumns[1][1],
                      this.global.myTasksSortsndPagingCriteria[0].sortingColumns[0][0], this.global.myTasksSortsndPagingCriteria[0].sortingColumns[0][1]);
    }
    else{
      this.loadMyTasks(0, 'SubmissionDate', 'DESC', 'SubmissionDate', 'DESC');
    }

  }
}

export class MenuItem {
  Title: string;
  TitleAr: string;
}
